<div class="dialog-bg show_animation" [ngClass]="{show_animation: show_animation,'full-height': fullHeight}" (mousedown)="bgClose($event)">
    <div class="dialog" [style.paddingTop]="margin+'%'" [style.paddingLeft]="margin+'%'"  (click)="bgClose($event)">
        <header class="bg-orange">{{title}} <button tabindex="1" class="ion" *ngIf="!modal" (click)="close()" #closeButton title="Закрыть!"> </button></header>
        <section>
            <ng-content></ng-content>
        </section>
        <footer class="bg-orange">
            <ng-content select="[dialog-footer]"></ng-content>
        </footer>
    </div>
</div>